/**
 * @generated SignedSource<<63be4c54a648d5a9d1b4928750f60d15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProposalFeedbackSummaryVoteTimeFragment$data = {
  readonly voteEndsAt: number;
  readonly voteStartsAt: number;
  readonly " $fragmentType": "ProposalFeedbackSummaryVoteTimeFragment";
};
export type ProposalFeedbackSummaryVoteTimeFragment$key = {
  readonly " $data"?: ProposalFeedbackSummaryVoteTimeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProposalFeedbackSummaryVoteTimeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProposalFeedbackSummaryVoteTimeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voteStartsAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "voteEndsAt",
      "storageKey": null
    }
  ],
  "type": "OnChainProposal",
  "abstractKey": null
};

(node as any).hash = "0d1bfc5634802fe68d7f62aa179f2324";

export default node;
